<template>
  <div class="draggable-demo">
    <div class="option" :style="{
      visibility: $parent.cardStatus === '布局预览' ? 'hidden' : 'visible',
    }">
      <div class="scrool-wrap" ref="contentBoxRef">
        <div class="scrool-box" ref="contentWrapRef">
          <draggable :list="list" :sort="false" :group="group" :clone="cloneDog">
            <!-- <div class="tab-box"> -->
            <div class="tab-item" v-for="item in list" :key="item.name">
              <div class="title">
                <img src="../assets/images/星.png" />
                {{ item.name }}
              </div>
              <div class="tab-image-box">
                <img class="tab-image" :src="getImageSrc(item)" alt="" @error="handleImageError" />
              </div>
            </div>
            <!-- </div> -->
          </draggable>
        </div>
      </div>

      <div class="left-btn scrool-btn">
        <img src="../assets/images/左1.png" alt="" @click="moveToolPosition('left')" />
      </div>
      <div class="right-btn scrool-btn">
        <img src="../assets/images/右1.png" alt="" @click="moveToolPosition('right')" />
      </div>

      <div class="opra-box">
        <div class="item" @click="$parent.cardStatus = '布局预览'">
          <img src="../assets/images/预览.png" alt="" />
          预览
        </div>
        <div class="item" @click="confirm">确认布局</div>
        <div class="item" @click="$parent.cardStatus = '取消布局'">
          取消布局
        </div>
      </div>
    </div>
    <div class="main">
      <div class="left-selected">
        <draggable class="clone" :list="cloneLeftList" group="clone">
          <div v-for="(item, index) in cloneLeftList" :key="index">
            <div class="wrap" :key="index">
              <el-tabs type="border-card" :class="{
                [item.size]: item.size,
                ['gridnum' + (item.gridnum ? item.gridnum : 1)]: true,
              }" v-model="item.active" @tab-click="tabClick">
                <el-tab-pane :label="child.name" :name="child.ename" v-for="child in item.data" :key="child.name">
                  <component :is="child.ename" :cardEchart="true"></component>
                </el-tab-pane>
              </el-tabs>
              <div class="tools">
                <el-select v-model="item.selected" size="mini" :multiple-limit="2" multiple collapse-tags
                  placeholder="添加多个选项卡" @change="hanldChange(index, 'cloneLeftList')" :teleported="false">
                  <el-option v-for="item1 in item.options" :key="item1.value" :label="item1.label" :value="item1.value"
                    :disabled="isDisabled(item.selected, item1.value)">
                  </el-option>
                </el-select>
                <img class="del-btn" src="../assets/images/删除.png" alt=""
                  @click="deleteProduct(index, 'cloneLeftList')" />
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="right-selected">
        <draggable class="clone" :list="cloneRightList" group="clone">
          <div v-for="(item, index) in cloneRightList" :key="index">
            <div class="wrap" :key="index">
              <el-tabs type="border-card" :class="{
                [item.size]: item.size,
                ['gridnum' + (item.gridnum ? item.gridnum : 1)]: true,
              }" v-model="item.active" @tab-click="tabClick">
                <el-tab-pane :label="child.name" :name="child.ename" v-for="child in item.data" :key="child.name">
                  <component :is="child.ename" :cardEchart="true"></component>
                </el-tab-pane>
              </el-tabs>
              <div class="tools">
                <el-select v-model="item.selected" size="mini" :multiple-limit="2" multiple collapse-tags
                  placeholder="添加多个选项卡" @change="hanldChange(index, 'cloneRightList')">
                  <el-option v-for="item1 in item.options" :key="item1.value" :label="item1.label" :value="item1.value"
                    :disabled="isDisabled(item.selected, item1.value)">
                  </el-option>
                </el-select>
                <img class="del-btn" src="../assets/images/删除.png" alt=""
                  @click="deleteProduct(index, 'cloneRightList')" />
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>

    <div class="bottom"></div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import Tqsk from "@/components/module/card/wqsk.vue";
import Risk from "@/components/module/card/risk.vue";
import ThreeRisk from "@/components/module/card/three-risk.vue";
import HourForest from "@/components/module/card/hour-forest.vue";
import ThreeForest from "@/components/module/card/three-forest.vue";
import Index from "@/components/module/card/index.vue";
import RainLive from "@/components/module/card/rain-live.vue";
import LiveForest from "@/components/module/card/live-forest.vue";
import Warn from "@/components/module/card/warn.vue";
import RainImage from "@/components/module/card/rain-image.vue";
import IndexNumber from "@/components/module/card/index-number.vue";
import Undeveloped from "@/components/module/card/undeveloped.vue";
import UltravioletRays from "@/components/module/card/ultraviolet-rays.vue";
import InstantRisk from "@/components/module/card/instant-risk.vue";
import MultiWeather from "@/components/module/card/multi-weather.vue";
import WaterTemperatureLive from "@/components/module/card/water-temperature-live.vue";
import draggable from "vuedraggable";

import { apiData } from "../api/index";
import TownWarn from "@/components/module/card/town-warn.vue";

export default {
  components: {
    draggable,
    Tqsk,
    Risk,
    HourForest,
    ThreeForest,
    Index,
    LiveForest,
    RainLive,
    Warn,
    RainImage,
    ThreeRisk,
    IndexNumber,
    UltravioletRays,
    InstantRisk,
    MultiWeather,
    WaterTemperatureLive,
    TownWarn,
    Undeveloped,
  },
  data() {
    return {
      list: [],
      devSuccessList: [
        {
          name: "天气实况",
          ename: "Tqsk",
          id: 19,
          size: "one",
        },
        {
          name: "24小时预报",
          ename: "HourForest",
          id: 9,
          size: "one",
        },
        {
          name: "三天预报",
          ename: "ThreeForest",
          id: 29,
          size: "one",
        },
        {
          name: "三天风险",
          ename: "Risk",
          id: 28,
          size: "one",
        },
        {
          name: "短临风险",
          ename: "ThreeRisk",
          id: 20,
          size: "one",
        },
        {
          name: "实况预报拼接",
          ename: "LiveForest",
          id: 36,
          size: "one",
        },
        {
          name: "1小时雨量图",
          ename: "RainImage",
          id: 44,
          size: "one",
        },
        {
          name: "预警信号",
          ename: "Warn",
          id: 37,
          size: "one",
        },
        {
          name: "雨量实况",
          ename: "RainLive",
          id: 43,
          size: "one",
        },
        {
          name: "适宜度",
          ename: "IndexNumber",
          id: 52,
          size: "one",
        },
        {
          name: "紫外线",
          ename: "UltravioletRays",
          id: 54,
          size: "one",
        },
        {
          name: "即时风险",
          ename: "InstantRisk",
          id: 56,
          size: "one",
        },
        {
          name: "综合天气",
          ename: "MultiWeather",
          id: 57,
          size: "one",
        },
        {
          name: "水温",
          ename: "WaterTemperatureLive",
          id: 58,
          size: "one",
        },
        {
          name: "水温",
          ename: "WaterTemperatureStation",
          id: 60,
          size: "one",
        },
        {
          name: "街镇预警",
          ename: "TownWarn",
          id: 61,
          size: "one",
        },
      ],
      cardIds: [19, 9, 29, 28, 20, 36, 44, 37, 43, 52, 54, 56, 57, 58, 60, 61],
      noCardIds: [],
      cloneLeftList: [],
      cloneRightList: [],
      group: {
        name: "clone",
        pull: "clone",
        put: false,
      },
      group1: {
        name: "clone1",
        pull: "clone1",
        put: false,
      },
      cardData: [],
      cloneIndex: 0,
    };
  },
  watch: {
    "$parent.cardStatus": {
      handler(val, oldVal) {
        this.$bus.$emit("changeCardData");
        // 隐藏对话框
        const el = document.querySelector(".config");
        const hideDialog = ["进入布局", "布局预览"];
        if (hideDialog.includes(val)) {
          el.style.display = "none";
        } else {
          el.style.display = "block";
        }
        // 获取默认布局
        if (val === "进入布局" && oldVal !== "布局预览") {
          const company = this.$route.params.company;
          const { unit } = JSON.parse(localStorage.getItem(company));
          console.log("unit", unit);
          const cardidsStr = unit.cardids;
          const cardids = cardidsStr != null ? cardidsStr.split(",") : [];
          const cardTabList = [];
          this.cardOptions.forEach((item) => {
            if (cardids.includes(String(item.id))) {
              const attr = this.devSuccessList.find(
                (v1) => Number(v1.id) === Number(item.id),
              );
              const ename = attr ? attr.ename : "Undeveloped";
              cardTabList.push({
                name: item.name,
                ename: ename,
                id: item.id,
                size: "one",
                gridnum: item.gridnum,
              });
              if (!this.cardIds.includes(item.id)) {
                this.noCardIds.push(item.id);
              }
            }
          });

          this.cardData = [];
          this.cloneLeftList = [];
          this.cloneRightList = [];
          const cardList = [
            "cardone",
            "cardtwo",
            "cardthree",
            "cardfour",
            "cardfive",
            "cardsix",
          ];
          cardList.forEach((item) => {
            const ids = unit[item] ? unit[item].split(",") : [];
            for (const id of ids) {
              const cards = this.cardOptions.find(
                (v) => Number(v.id) === Number(id),
              );
              const card = cards || null;
              if (card) {
                const attr = this.devSuccessList.find(
                  (v1) => Number(v1.id) === Number(card.id),
                );
                const ename = attr ? attr.ename : "Undeveloped";
                cardTabList.push({
                  name: card.name,
                  ename: ename,
                  id: card.id,
                  size: "one",
                  gridnum: card.gridnum,
                });
                if (!this.cardIds.includes(card.id)) {
                  this.noCardIds.push(card.id);
                }
              }
            }
            this.cardData.push(ids);
          });
          const cardSet = cardTabList.filter((item, index, self) => {
            return self.findIndex((t) => t.id === item.id) === index;
          });
          this.list = cardSet;
          this.cardData.forEach((ids, index) => {
            const item =
              this.list.find((item) => Number(item.id) === Number(ids[0])) ||
              {};
            // console.log('item', item)
            const options = [];

            this.list.forEach((item1) => {
              if (item1.size === item.size) {
                options.push({
                  label: item1.name,
                  value: item1.id,
                });
              }
            });
            const obj = {
              size: item.size,
              active: item.ename,
              data: [],
              selected: [],
              gridnum: 1,
              options,
            };
            ids.forEach((id, index) => {
              const item =
                this.list.find((item) => item.id === Number(id)) || {};
              obj.data.push({
                name: item.name,
                ename: item.ename,
              });
              if (item.gridnum && item.gridnum > obj.gridnum) {
                obj.gridnum = item.gridnum;
              }
              obj.selected.push(item.id);
            });
            if (index < 3) {
              this.cloneLeftList.push(obj);
            } else {
              this.cloneRightList.push(obj);
            }
          });
        }
      },
    },
    cloneLeftList() {
      this.isOverCardContent("cloneLeftList");
    },
    cloneRightList() {
      this.isOverCardContent("cloneRightList");
    },
  },
  mounted() {
    this.getRightCardData();
  },
  computed: {
    ...mapState("home", ["objsList", "activeCountyId", "cardOptions"]),
  },
  methods: {
    ...mapMutations("home", ["changeCardTypes"]),
    cloneDog({ name, ename, size, id, gridnum }) {
      if (!gridnum || gridnum === 0) {
        gridnum = 1;
      }
      const flag = this.hasClone(name);
      if (flag) {
        this.$message.error("卡片已存在，请删除卡片内容再添加");
        return;
      }

      const options = [];
      this.list.forEach((item) => {
        if (item.size === size) {
          options.push({
            label: item.name,
            value: item.id,
          });
        }
      });
      this.cloneIndex = this.cloneIndex + 1;
      const data = {
        index: this.cloneIndex,
        size,
        active: ename,
        gridnum,
        data: [
          {
            name,
            ename,
          },
        ],
        selected: [id],
        options,
      };
      console.log("cloneData:", data);
      const params = {
        cardone: this.cloneLeftList[0]
          ? this.cloneLeftList[0].selected.join(",")
          : "",
        cardtwo: this.cloneLeftList[1]
          ? this.cloneLeftList[1].selected.join(",")
          : "",
        cardthree: this.cloneLeftList[2]
          ? this.cloneLeftList[2].selected.join(",")
          : "",
        cardfour: this.cloneRightList[0]
          ? this.cloneRightList[0].selected.join(",")
          : "",
        cardfive: this.cloneRightList[1]
          ? this.cloneRightList[1].selected.join(",")
          : "",
        cardsix: this.cloneRightList[2]
          ? this.cloneRightList[2].selected.join(",")
          : "",
      };
      console.log("params", params);
      return data;
    },

    hasClone(name) {
      let flag = false;
      const cloneData = ["cloneRightList", "cloneLeftList"];
      cloneData.forEach((dataName) => {
        this[dataName].forEach((item) => {
          item.data.forEach((item) => {
            if (item.name === name) {
              flag = true;
            }
          });
        });
      });
      return flag;
    },

    deleteProduct(index, name) {
      const item = this[name][index];
      if (item.gridnum === 3) {
        for (let i = 0; i < 3; i++) {
          this.$delete(this[name], i);
        }
      }
      this.$delete(this[name], index);
    },
    hanldChange(index, name) {
      const data = [];
      this[name][index].selected.forEach((item) => {
        const num = this.list.findIndex((i) => i.id === item);
        const { ename, name } = this.list[num];
        data.push({
          ename,
          name,
        });
      });
      this[name][index].data = data;
    },
    getImageSrc(item) {
      // 如果 id 在未开发列表中，直接返回未开发图片
      if (this.noCardIds.includes(item.id)) {
        try {
          return require("@/assets/images/未开发.png");
        } catch {
          return "";
        }
      }

      // 尝试加载对应的图片
      try {
        return require(`@/assets/images/${item.name}.png`);
      } catch (e) {
        // 如果图片不存在，返回未开发图片
        try {
          return require("@/assets/images/未开发.png");
        } catch {
          return "";
        }
      }
    },
    // 错误处理：如果加载失败，替换为未开发图片
    handleImageError(event) {
      // 防止无限循环（如果未开发图片也加载失败）
      if (!event.target.src.includes("未开发.png")) {
        event.target.src = require("@/assets/images/未开发.png");
      }
    },
    // 判断是否超出卡片数量
    isOverCardContent(typeNmae) {
      let total = 0;
      this[typeNmae].forEach((item) => {
        let size = 1;
        if (item.gridnum !== undefined) {
          size = item.gridnum;
        }
        if (item.data && item.data.length === 0) {
          size = 0;
        }
        total = total + size;
      });
      if (total > 3) {
        const index = this[typeNmae].findIndex(
          (item) => item.index === this.cloneIndex,
        );
        this[typeNmae].splice(index, 1);
        this.$message.error(
          "卡片内容已满，请删除卡片再添加 如需添加卡片内容请下拉选择",
        );
      }
    },

    // 卡片点击
    tabClick(node) {
      const tabItem = this.list.find((item) => item.name === node.label);
      const emitName = `change${tabItem.ename}Resize`;
      this.$bus.$emit(emitName);
    },

    // 获取卡片的数据
    async getRightCardData() {
      const index = this.objsList.findIndex(
        (item) => item.id === this.activeCountyId,
      );
      const lon = (Math.round(this.objsList[index].lat / 0.05) * 0.05)
        .toFixed(2)
        .replace(/\./g, "");
      const lat = (Math.round(this.objsList[index].lon / 0.05) * 0.05)
        .toFixed(2)
        .replace(/\./g, "");
      try {
        const slideliveResult = await apiData.sildeLive(
          this.objsList[index].id,
          24,
          "obj"
        );
        this.changCardData({
          type: "slideLive",
          data: slideliveResult.data,
        });
      } catch (error) { }
      try {
        const riskShortResult = await apiData.riskShort(this.activeCountyId);
        this.changCardData({
          type: "riskShort",
          data: riskShortResult,
        });
      } catch (error) { }
      try {
        const indexNumberResult = await apiData.indexNumber(
          this.activeCountyId,
        );
        this.changCardData({
          type: "indexNumber",
          data: indexNumberResult,
        });
      } catch (error) { }
      try {
        const giftDataResult = await apiData.giftData(lat, lon);
        this.changCardData({
          type: "giftData",
          data: giftDataResult,
        });
      } catch (error) { }
      try {
        const wheatherLiveResult = await apiData.queryWheatherLiveData(this.activeCountyId);
        const tqskDateResult = wheatherLiveResult.data;
        tqskDateResult.temp = (tqskDateResult.t).toFixed(1);
        tqskDateResult.p = (tqskDateResult.p).toFixed(1);
        this.changCardData({
          type: "tqskDate",
          data: tqskDateResult,
        });
      } catch (error) { }

      try {
        const riskForeResult = await apiData.riskFore(this.activeCountyId);
        this.changCardData({
          type: "riskFore",
          data: riskForeResult,
        });
      } catch (error) { }

      try {
        // const RainImageResult = await apiData.rainImage()
        // this.changCardData({
        //   type: 'rainImage',
        //   data: RainImageResult
        // })
      } catch (error) { }
    },

    isDisabled(ids, id) {
      let flag = false;
      const idArr = [];
      const cloneData = ["cloneRightList", "cloneLeftList"];
      cloneData.forEach((name) => {
        this[name].forEach((item) => {
          idArr.push(...item.selected);
        });
      });
      if (idArr.includes(id) && !ids.includes(id)) {
        flag = true;
      }
      return flag;
    },

    // 滚动按钮的点击
    moveToolPosition(type) {
      const el = this.$refs.contentBoxRef;
      const contentWrapWidth = el.scrollWidth;
      const contentBoxEl = this.$refs.contentBoxRef;
      const contentBoxWidth = contentBoxEl.offsetWidth;
      const maxMoveWidth = contentWrapWidth - contentBoxWidth;
      if (type === "right" && el.scrollLeft < maxMoveWidth) {
        const left = el.scrollLeft + contentBoxWidth;
        el.scrollTo({
          left,
          behavior: "smooth",
        });
      } else {
        const left = el.scrollLeft - contentBoxWidth;
        el.scrollTo({
          left,
          behavior: "smooth",
        });
      }
    },

    // 确认布局
    async confirm() {
      const company = this.$route.params.company;
      const { unit } = JSON.parse(localStorage.getItem(company));
      const params = {
        cardone: this.cloneLeftList[0]
          ? this.cloneLeftList[0].selected.join(",")
          : "",
        cardtwo: this.cloneLeftList[1]
          ? this.cloneLeftList[1].selected.join(",")
          : "",
        cardthree: this.cloneLeftList[2]
          ? this.cloneLeftList[2].selected.join(",")
          : "",
        cardfour: this.cloneRightList[0]
          ? this.cloneRightList[0].selected.join(",")
          : "",
        cardfive: this.cloneRightList[1]
          ? this.cloneRightList[1].selected.join(",")
          : "",
        cardsix: this.cloneRightList[2]
          ? this.cloneRightList[2].selected.join(",")
          : "",
        unitid: unit.id,
      };
      console.log("params", params);
      const unitResult = await apiData.changeCardStatus(params);
      console.log("unitResult", unitResult)
      if (unitResult.status === 200) {
        this.$parent.cardStatus = "取消布局";
        this.$message.success("修改布局成功");
        const unitinfo = JSON.parse(localStorage.getItem(company));
        localStorage.setItem(
          company,
          JSON.stringify({
            unit: unitResult.data,
            token: unitinfo.token,
          }),
        );

        this.changeCardTypes(unitResult.data);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.draggable-demo {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2000;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  // padding: 0px 61px 0;
  overflow: hidden;
  // background: #081E33FF;
  color: #fff;
  pointer-events: none;

  .option {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 0 0 1.7vh;
    height: 15vh;
    padding: 0vw 17.29vw 0 8.85vw;
    pointer-events: auto;
    background: url("../assets/images/card-bg.png") no-repeat;
    background-size: 100% auto;
    background-position: center bottom;

    .scrool-btn {
      position: absolute;
      left: 4.64vw;
      bottom: 2.8vw;
      cursor: pointer;

      img {
        width: 1.88vw;
      }
    }

    .right-btn {
      left: auto;
      right: 13.18vw;
    }

    .opra-box {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 24px;
      box-sizing: border-box;
      height: 100%;
      width: 8.13vw;
      padding: 0.8vh 0 1.3vh 0;

      .item {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex: 1;
        box-sizing: border-box;
        padding-right: 3.07vw;
        font-size: 0.83vw;
        font-weight: 600;
        color: #ffffff;
        cursor: pointer;
        background: url("../assets/images/预览框.png") no-repeat;
        background-size: 100% 100%;

        img {
          width: 0.89vw;
          margin-right: 0.26vw;
        }
      }

      .item:nth-child(2) {
        margin: 0.6vh 0;
        background: url("../assets/images/确认布局框.png") no-repeat;
        background-size: 100% 100%;
      }

      .item:nth-child(3) {
        background: url("../assets/images/取消布局框.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    .scrool-wrap::-webkit-scrollbar {
      display: none;
    }

    .scrool-wrap {
      width: calc(100vw - 17vw);
      overflow: hidden;
      overflow-x: auto;
      display: flex;

      .scrool-box {
        float: left;

        >div {
          display: flex;
          justify-content: center;
          float: left;
          flex: 1;
          overflow: hidden;
          // .tab-box{

          .tab-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 0.94vw;
            margin-bottom: 1.09vw;

            .title {
              display: flex;
              align-items: center;
              margin: 0.99vw 0 0.52vw;

              img {
                margin-right: 0.16vw;
                width: 0.68vw;
              }
            }

            .tab-image-box {
              border-radius: 0.26vw;
              border: 0.05vw solid #fff;
              height: 5rem;
              overflow: hidden;

              .tab-image {
                width: calc((83vw - 8.64vw) / 9);
              }
            }
          }

          // }
        }
      }
    }
  }

  .del-btn {
    margin: 0 0.68vw;
    width: 0.78vw;
    cursor: pointer;
  }

  .main {
    display: flex;
    justify-content: space-between;
    flex: 1;
    overflow-y: auto;
  }

  .left-selected {
    width: 25.73vw;
    overflow: hidden;
    margin-left: 1.04vw;
    pointer-events: auto;
    border: 0.05vw dashed rgba(255, 94, 61, 0.5);
  }

  .right-selected {
    width: 25.73vw;
    overflow: hidden;
    margin-right: 1.04vw;
    pointer-events: auto;
    border: 0.05vw dashed rgba(255, 94, 61, 0.5);
  }

  .clone {
    border: 0.05vw dashed rgba(255, 94, 61, 0.5);
    min-height: 75vh;

    .wrap {
      position: relative;
      background: rgba(13, 66, 112, 0.7);
      border-radius: 0.63vw;

      .gridnum2 {
        height: 51vh !important;
      }

      .gridnum3 {
        height: 73.8vh !important;
      }

      /deep/ .el-tabs {
        display: flex;
        flex-direction: column;
        height: 23.5vh;
        overflow-y: auto;
        margin-bottom: 2vh;
        position: relative;
        background: transparent;
        border: 0 !important;

        .clone-child {
          border: 0.05vw dashed red;
          height: 9.38vw;
        }
      }

      /deep/ .el-tabs__header {
        display: flex;
        align-items: center;
        height: 3.02vw;
        background: #10416e;
        border: 0;
        border-top-left-radius: 0.63vw !important;
        border-top-right-radius: 0.63vw !important;
      }

      /deep/ .el-tabs__content {
        flex: 1;
        overflow-y: auto;
        margin-bottom: 8px;
        scrollbar-width: none;
      }

      /deep/ .el-tabs__content::-webkit-scrollbar {
        display: none;
        /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
      }

      /deep/ .el-tabs__nav {
        display: flex;
      }

      /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        display: flex;
        align-items: center;
        padding-left: 0.78vw;
        padding-right: 0;
        background: transparent;
        border: 0 !important;
        color: #fff;
        font-size: 0.94vw;
        font-weight: 600;
      }

      /deep/ .el-select__tags {
        flex-wrap: nowrap;
        overflow: hidden;
      }

      /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active::before {
        display: inline-block;
        content: "";
        width: 0.68vw;
        height: 0.89vw;
        margin-right: 0.57vw;
        background: url("../assets/images/星.png") no-repeat;
        background-size: 100%;
      }

      .tools {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0vw;
        top: 0.57vw;
        z-index: 999;

        .el-select {
          width: 8.8vw;
          background: #14426a;
          border-radius: 0.21vw;
          outline: none;

          // border: 1px solid rgba(255, 255, 255, .33);
          .el-input {
            height: 100%;
          }

          /deep/ .el-input__inner {
            height: 1.93vw;
            border: 1px solid rgba(255, 255, 255, 0.33);
            background: transparent !important;
          }

          /deep/ .el-tag {
            background: #245b8c;
            padding: 0.16vw 0.26vw;
            color: #fff;
            font-size: 0.83vw;
          }
        }
      }

      .two {
        height: 49vh;

        .clone-child {
          border: 0.05vw dashed red;
          height: 21.88vw;
        }
      }

      .three {
        height: 37.5vw;

        .clone-child {
          border: 0.05vw dashed red;
          height: 32.29vw;
        }
      }
    }
  }
}

/deep/ .el-tab-pane .content {
  padding-top: 1vh;
  background: transparent;
}

/deep/ .el-tab-pane .publish-time {
  display: none;
}

/deep/ #pane-Tqsk .content {
  padding-top: 3vh;
}

/deep/ .el-select__caret {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-select__caret::after {
  content: "";
  width: 0.57vw;
  height: 0.31vw;
  background: url("../assets/images/card-more.png") no-repeat;
  background-size: 100%;
  transform: rotate(-180deg);
}

/deep/ .el-select__caret::before {
  content: "";
}

.bottom {
  height: 9vh;
  width: 100%;
  pointer-events: auto;
}
</style>
